// Removed the react-helmet dependency and replace with createPortal, for nextjs viewer performance.
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { installFonts } from '../../actions/fonts';
import get from 'lodash/get';
import size from 'lodash/size';

function FontManager(props) {
  const [isMounted, setIsMounted] = useState(false);

  const availableFonts = useSelector(state => {
    const fonts = get(state, 'fonts.items') || [];
    const installed = get(state, 'fonts.installed') || [];
    return fonts.filter(font => {
      return installed.some(item => item === font.id);
    }).filter(font => font.styleSheet != null);
  });

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return createPortal(
    <>
      {availableFonts.map(font => (
        <link 
          key={font.id} 
          rel="stylesheet" 
          type="text/css" 
          href={font.styleSheet} 
        />
      ))}
    </>,
    document.head
  );
}

const useFont = (fonts) => {
  const dispatch = useDispatch();

  const fontToBeInstalled = useSelector(state => {
    const installed = get(state, 'fonts.installed');
    const availableFonts = get(state, 'fonts.items') || [];

    var filtered = (fonts || []).map(font => {
      if(typeof(font) === 'string'){
        return availableFonts.find(item => item.id === font);
      }

      return font;
    }).filter(font => {
      return font != null;
    }).filter(font => {
      return !installed.some(item => item === font.id);
    });

    return filtered;
  }, shallowEqual);

  useEffect(() => {
    if(size(fontToBeInstalled) > 0){
      dispatch(installFonts(fontToBeInstalled));
    }
  }, [fontToBeInstalled]);
}

const Fonts = {
  Manager: FontManager,
  useFont: useFont
};

export default Fonts;
